import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'components/common/icons';
import { CopyButton } from '.';

const SecretField = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  class extends Component {
    state = {
      hidden: true
    };

    toggleHidden = () => {
      this.setState({ hidden: !this.state.hidden });
    };

    render() {
      const { messages, theme, value } = this.props;
      const { hidden } = this.state;

      return (
        <div className="secret">
          <div className="wrapper">
            <div className={`value ${hidden ? 'hidden' : ''}`}>
              {hidden
                ? value
                    .split('')
                    .map((c) => '•')
                    .join('')
                : value}
            </div>

            <button
              aria-label={hidden ? messages.commonUnhide : messages.commonHide}
              className="toggle"
              data-tooltip={
                hidden ? messages.commonUnhide : messages.commonHide
              }
              onClick={this.toggleHidden}
            >
              <Icon icon={hidden ? 'eye' : 'eye-slash'} />
            </button>
          </div>

          <CopyButton
            category="light"
            style={{ marginLeft: 10 }}
            successText={messages.commonCopied}
            text={messages.commonCopy}
            value={value}
          />

          <style jsx>{`
            .secret {
              display: inline-flex;
              margin: 2px 0;
            }
            .wrapper {
              background-color: ${theme.lightGrey};
              border-radius: 5px;
              color: ${theme.textColorLight};
              font-size: 1.4rem;
              font-weight: 600;
              padding: 8px 47px 8px 12px;
              position: relative;
            }
            .value.hidden {
              letter-spacing: 2px;
            }
            .toggle {
              background-color: transparent;
              border: 0;
              color: ${theme.textColorLighter};
              cursor: pointer;
              font-size: 1.4rem;
              outline: 0;
              position: absolute;
              text-align: center;
              transition: color 0.3s;
              top: 2px;
              right: 2px;
              bottom: 2px;
              width: 34px;
            }
            .toggle:focus,
            .toggle:hover {
              color: ${theme.textColorLight};
            }
          `}</style>
        </div>
      );
    }
  }
);

export default SecretField;
